import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'info' | 'success' | 'warning' | 'error';

export interface ToastItem {
  id: string;
  message: string;
  type: ToastType;
  createdAt: number;
  durationMs: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts$ = new BehaviorSubject<ToastItem[]>([]);
  readonly toasts$ = this._toasts$.asObservable();

  show(message: string, type: ToastType = 'info', durationMs: number = 3500): void {
    const toast: ToastItem = {
      id: crypto?.randomUUID?.() ?? String(Date.now() + Math.random()),
      message,
      type,
      createdAt: Date.now(),
      durationMs
    };

    const next = [...this._toasts$.value, toast];
    this._toasts$.next(next);

    setTimeout(() => this.dismiss(toast.id), durationMs);
  }

  dismiss(id: string): void {
    const next = this._toasts$.value.filter(t => t.id !== id);
    this._toasts$.next(next);
  }

  clear(): void {
    this._toasts$.next([]);
  }
}
